const initialState = {
  tour: [{ id: "", sub: "" }],
  dailyReward:{}
};

const _ConfigsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TOUR":
      return {
        ...state,
        tour: [...state.tour, action.payload.tour],
      };
    case "CLEAR_CONFIGS":
      return initialState;
    case "DAILY_REWARD_INFO":
      return {
        ...state,
        dailyReward: action.payload.dailyReward,
      };
    default:
      return state;
  }
};

export default _ConfigsReducer;
